import React, {useState} from "react"
import Conditions from './Conditions/conditions';
import '../bud.css';

const Forecast = () =>{

    let [city, setCity] = useState('');
    let [unit, setUnit] = useState('metric');

    let [responseObj, setResponseObj] = useState({});

    const uriEncodedCity = encodeURIComponent(city);

    function getForecast(e){
       e.preventDefault();
        fetch(`https://community-open-weather-map.p.rapidapi.com/weather?q=${uriEncodedCity}&lat=0&lon=0&callback=&id=2172797&lang=null&units=${unit}&mode=xml%2C%20html`, {
	"method": "GET",
	"headers": {
		"x-rapidapi-key": "e316d60d8emsh28b8363aea078b3p13ccb0jsna71486b41a20",
		"x-rapidapi-host": "community-open-weather-map.p.rapidapi.com"
	}
})
.then(response => response.json())
       .then(response => {
           setResponseObj(response)
       })

    };

    return(
        <div>
        <h2>Find Current Weather Conditions</h2>
           
        <form onSubmit={getForecast}>
                <input
                    type="text"
                    placeholder="Enter City"
                    maxLength="50"
                    value={city}
                    className="TextInput"
                    onChange={(e) => setCity(e.target.value)}
                    />
                <label className="Radio">
                    <input
                        type="radio"
                        name="units"
                        checked={unit === "imperial"}
                        value="imperial"
                        onChange={(e) => setUnit(e.target.value)}
                        />
                    Fahrenheit
                </label>
                <label className="Radio">
                    <input
                        type="radio"
                        name="units"
                        checked={unit === "metric"}
                        value="metric"
                        onChange={(e) => setUnit(e.target.value)}
                        />
                    Celcius
                </label>
                <button className="Button" type="submit">Get Forecast</button>
            </form>
           <Conditions responseObj={responseObj} />
        </div>
    )
}

export default Forecast;